import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AccountPage from '../components/AccountPage';
import Typography from '@material-ui/core/Typography';
import { ServiceRequestAPI } from '../../../api';
import Button from '../../../components/Button';
import RequestItemList from '../components/RequestItemList';
import Loader from '../../../components/PulseLoader';
import PlaceholderImg from '../../../assets/document-placeholder.svg';
import { useHistory } from 'react-router-dom';
import * as track from '../../../lib/track';

const useStyles = makeStyles(() => ({
  section: {
    padding: '2rem 0 1rem 0',
  },
  noItems: {
    width: '13rem',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  img: {
    width: '5rem',
    margin: '1rem',
    overflow: 'hidden',
    display: 'block',
  },
}));

const RequestsPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);

  const clickFindProvider = () => {
    track.sendEvent('user account new service request button', 'click', {});
    history.push('/requestmatch');
  };

  const getRequests = async () => {
    setLoading(true);
    try {
      const { payload } = await ServiceRequestAPI.listRequests();
      setRequests(payload);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRequests();
  }, []);

  if (loading) {
    return (
      <AccountPage>
        <Loader />
      </AccountPage>
    );
  }

  return (
    <AccountPage>
      <Typography variant="h3" gutterBottom>You have {requests.length === 0 ? 'no' : requests.length} open service requests.</Typography>
      <div className={classes.section}>
        {requests.length === 0 ? (
          <div className={classes.noItems}>
            <img
              className={classes.img}
              src={PlaceholderImg}
              alt="placeholder"
            />
            <Typography variant="body2" align="center" gutterBottom>Start a new request and make a step towards achieving your goals!</Typography>
          </div>
        ) : (
          <RequestItemList
            requests={requests}
          />
        )}
        <Button label="New service request" color="secondary" pointer="right" onClick={clickFindProvider} style={{marginTop: '2rem', color: 'white'}}/>
      </div>
    </AccountPage>
  );
};

export default RequestsPage;
